export default __webpack_public_path__ + "static/media/meme.956b4621.png";